import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckmark = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 52 52",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		className: "check",
		fill: "none",
		d: "M14.1 27.2l7.1 7.2 16.7-16.8"
	})
});
export default SvgCheckmark;
